import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import styles from "../../components/globalstyles";
import { Link } from "react-router-dom";
import useLogos from "../../hooks/useLogos";

const Message = () => {
  const { logo: logoBarra, logoClaro } = useLogos();

  return (
    <>
      {/* HEADER (SOLO MOVIL) */}
      <Box sx={styles.barramovil}>
        <img
          src={logoBarra}
          alt="Radar Freim"
          style={{ maxWidth: "180px", objectFit: "contain" }}
        />
      </Box>

      <Grid container sx={styles.root}>
        {/* VISTA IZQUIERDA */}
        <Grid item md={7} sx={styles.image}>
          <img
            alt="Radar Freim"
            src={logoClaro}
            style={{
              maxWidth: "40%",
              maxHeight: "140px",
              width: "auto",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Grid>
        {/* VISTA DERECHA */}
        <Grid container item md={5} px={4}>
          <Stack
            width="100%"
            spacing={2}
            px={3}
            justifyContent="center"
            alignItems="center"
          >
            <ErrorOutlineRoundedIcon
              sx={{ color: "red", height: "auto", width: "40%" }}
            />
            <Typography align="center">
              Hubo un error en tu petición, intenta nuevamente.
            </Typography>
            <Button LinkComponent={Link} to="/">
              Continuar
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default Message;
